export default "__VITE_ASSET__Yf3DiRwK__"